module.exports = __webpack_public_path__ + "img/1920_icon_line_nbg.e2a24158.svg";